import { SelectorData } from "../types";
import { useRouter } from "next/router";

const MobileSelector = ({ header, idx }: SelectorData): JSX.Element => {
  const router = useRouter();
  const onClick = () => {
    router.push({
      hash: `${idx + 1}`,
    });
  };
  return (
    <div
      key={idx}
      onClick={onClick}
      className="px-4 py-1 outline-none cursor-pointer focus:bg-grey-50 focus:font-bold hover:bg-grey-50 hover:font-bold"
    >
      {header}
    </div>
  );
};

export default MobileSelector;
